import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { useSelector } from 'react-redux';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error untyped
import FormattedCurrencyLabel from 'I18n/components/FormattedCurrencyLabel';
//@ts-expect-error untyped
import formatCurrencyName from 'I18n/utils/formatCurrencyName';
//@ts-expect-error untyped
import { currencyStyles } from 'I18n/internal/utils/CurrencyLabelFormatters';
import { getCompanyCurrency } from '../../selectors/multiCurrencySelectors';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrencySelectOption = _ref => {
  let {
      children,
      option: {
        value
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const companyCurrency = useSelector(getCompanyCurrency);
  return /*#__PURE__*/_jsx("span", Object.assign({
    title: formatCurrencyName(value, currencyStyles.long)
  }, rest, {
    children: value === companyCurrency ? /*#__PURE__*/_jsxs(View, {
      paddingBlock: "200",
      paddingInline: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedCurrencyLabel, {
        currencyCode: value,
        currencyStyle: currencyStyles.long
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-primary-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "multicurrencyPanel.companyCurrency"
          })
        })
      })]
    }) : children
  }));
};
export default CurrencySelectOption;